import { createFileRoute } from "@tanstack/react-router";
import FamilyOfficesInversores from "@/pages/FamilyOfficesInversores";

export const Route = createFileRoute("/family-offices-inversores")({
  component: FamilyOfficesInversores,
});
